import * as React from 'react';
import { useActions } from '../schemaModalActions';
import { ModalGroup, ModalGroups } from '../../ModalGroup/modalGroup';
import { AuditData } from '../../AuditData/auditData';
import { useSelector } from '../../../utils/useSelector';

export const PageSetup = () => {
  const name = useSelector(s => s.schemaModal?.name || '');
  const description = useSelector(s => s.schemaModal?.description || '');
  const { setSchemaSetting } = useActions();

  return (
    <ModalGroups>
      <ModalGroup>
        <div>
          <label htmlFor="dataTypeName">Data Type Name</label>
          <div className="input-group">
            <input
              id="dataTypeName"
              type="text"
              className="form-control"
              value={name}
              onChange={e => {
                setSchemaSetting({ name: e.target.value });
              }}
            />
          </div>
        </div>
        <div>
          <label htmlFor="viewDescription">Description</label>
          <div className="input-group">
            <textarea
              className="form-control"
              id="viewDescription"
              rows={3}
              maxLength={2000}
              value={description}
              onChange={e => {
                setSchemaSetting({ description: e.target.value });
              }}
            />
          </div>
        </div>
        <AuditData dataType="schema" />
      </ModalGroup>
    </ModalGroups>
  );
};
